import { exportToExcel } from "./exportUtils";

export const exportAppointmentData = (appointments) => {
  if (!appointments || appointments.length === 0) {
    throw new Error("No appointment records available to export.");
  }

  const exportData = appointments.map((appt) => {
    const fullName = appt.customerName || `${appt.firstName || ""} ${appt.lastName || ""}`.trim() || "No Name";
    const appointmentDate = appt.appointmentDate || appt.createdAt;
    
    let displayNote = appt.stageNotes?.appointment_scheduled || appt.appointmentNote || "";
    if (displayNote && typeof displayNote === 'string') {
      if (displayNote.includes(' | Note: ')) {
        displayNote = displayNote.split(' | Note: ')[1].trim();
      } else if (
        displayNote.startsWith('Lead Status changed') ||
        displayNote.startsWith('Design Status changed') ||
        displayNote.startsWith('Appointment scheduled') ||
        displayNote.startsWith('Lead assigned') ||
        displayNote.startsWith('Lead reassigned')
      ) {
        displayNote = "";
      }
    }

    return {
      "Verve ID": appt.customId || "—",
      "Customer Name": fullName,
      "Phone": appt.phoneNumber || appt.phone || "—",
      "Email": appt.email || "—",
      "Last Note": displayNote || "—",
      "Appointment Date": appointmentDate 
        ? new Date(appointmentDate).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) 
        : "—"
    };
  });

  exportToExcel(exportData, {
    filename: `Appointment_Scheduled_Leads_${new Date().toISOString().split("T")[0]}`,
    sheetName: "Appointments"
  });
};
